<template>
  <main class="main-content">
    <div class="content-box">
      <div class="row">
        <div class="col-md-12 col-lg-6">
          <!-- Character box -->
          <div class="content-box__character-box p-3">
            <div class="row">
              <div class="col-md-3 mobileScreenMedia">
                <div class="character_weapon-box">
                  <div class="weapon-img">
                    <!-- <img src="/weapsmithing/images/sword.png" alt="" /> -->
                  </div>
                </div>
                <div class="character_weapon-box my-3">
                  <div class="weapon-img">
                    <!-- <img src="" alt="" /> -->
                  </div>
                </div>
                <div class="character_weapon-box">
                  <div class="weapon-img">
                    <!-- <img src="" alt="" /> -->
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="character-box_large-card w-100">
                  <div class="large-card_img">
                    
                  </div>
                </div>
                <h5
                  class="
                    text-white text-uppercase text-center
                    py-2
                    font-weight-bold
                  "
                >
                  character
                </h5>
              </div>
              <div class="col-md-3 mobileScreenMedia">
                <div class="character_weapon-box">
                  <div class="weapon-img">
                    <!-- <img src="" alt="" /> -->
                  </div>
                </div>
                <div class="character_weapon-box my-3">
                  <div class="weapon-img">
                    <!-- <img src="" alt="" /> -->
                  </div>
                </div>
                <div class="character_weapon-box">
                  <div class="weapon-img">
                    <!-- <img src="" alt="" /> -->
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Select Weapon  -->
          <section>
            <div
              class="selected-weapon-name d-flex justify-content-center mt-3"
            >
              <div class="selected-box py-2 mx-4">
                <div class="weapon-img">
                  <!-- <img src="/weapsmithing/images/sword.png" alt="" /> -->
                </div>
                <h6
                  class="
                    text-white text-capitalize text-center
                    font-weight-bold
                    text-truncate
                    weapon-name
                  "
                >
                  weapon name
                </h6>
              </div>
              <div class="selected-box py-2">
                <div class="weapon-img p-1">
                  <!-- <img src="/weapsmithing/images/sword.png" alt="" /> -->
                </div>
                <h6
                  class="
                    text-white text-capitalize text-center
                    font-weight-bold
                    text-truncate
                    weapon-name
                  "
                >
                  weapon name
                </h6>
              </div>
            </div>
          </section>
        </div>
        <!--=== Character box End ===-->

        <!--=== Inventory Box ===-->
        <div class="col-md-12 col-lg-6">
          <div class="inventory-wrapper">
            <h3 class="text-center text-uppercase py-3">Inventory</h3>
            <div class="inventory-content">
              <div class="scrollbar">
                <div class="row justify-content-center" v-if="!isLoading">
                  <div class="col-lg-4 col-sm-4"  v-for="(item, i) in info"
                  :key="i"
                  :row="item">
                    <div class="inventory-content_card">
                      <div class="card-img">
                        <img :src="getImage(item.meta.immutable_data.img)" alt="" />
                        <span class="card-count">{{item.count}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="btn-container">
            <button class="btn btn-primary" @click="filter('weapon')">weapon</button>
            <button class="btn btn-primary"  @click="filter('armor')">Armor</button>
            <button class="btn btn-primary"  @click="filter('character')">character</button>
            <button class="btn btn-primary"  @click="filter('tool')">tool</button>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
// @ is an alias to /src
import router from "@/router";
import ApiService from "@/services";
// import Sidebar from "../components/Sidebar.vue";
// import AssetCard from "@/components/AssetCard";
import { mapGetters } from "vuex";
export default {
  name: "Home",
  components: {
    // AssetCard,
    // Sidebar,
  },
  computed: {
    ...mapGetters(["woods","leathers","metals","loaded","weapons"]),
  },
  data() {
    return {
      userFilter: null,
      authenticator: null,
      info: null,
      apiRes: null,
      collections: null,
      searchTerm: "All Weapons",
      isLoading: false,
      fullPage: true,
      status: false,
      assetId: "",
      row: {},
      assetIds: [],
      showModal: false,
      error: false,
      rarity: "All RARITY",
      activeMenuSearch: false,
      activeMenu: false,
    };
  },
  mounted() {
    if (!localStorage.getItem("wax_user")) {
      router.push("/login");
    }
    this.authenticator = localStorage.getItem("session-authenticator");
    this.init();
  },
  methods: {
    showDetails(row) {
      this.showReadyButton = true;
      this.row = row;
    },
    getImage(hash) {
      return ApiService.getImgUrl(hash, false);
    },
    filter(schema){
      this.info = this.apiRes.filter(el => el.meta.schema.schema_name == schema);
    },
    async created() {
      await this.$store.dispatch("getWeapons");
    },
    async init() {
      this.isLoading = true;
      let result = await ApiService.getHolders();
          if (result.length > 0) {
            this.apiRes = result;
            this.info = result;
          } else {
            this.info = [];
          }
          this.loading = false;
          this.isLoading = false;
    },
  },
};
</script>
<style scoped>
img{ width: 100%;}
.card-count{
  position: relative;
  bottom: 26px;
}
</style>